import React, { FC, ReactElement, MouseEvent } from 'react'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const LockWalletIcon: FC<{
	className?: string
	width?: number
	height?: number
	onClick?: (evt: MouseEvent) => void
}> = (props): ReactElement => {
	return (
		<svg
			onClick={props.onClick}
			viewBox="0 0 24 24"
			fill="none"
			className={props.className}
			width={props.width}
			height={props.height}
			role={props.onClick ? "button" : undefined}
			tabIndex={props.onClick ? 0 : undefined}
			onKeyDown={onKeyboardClick(props.onClick)}
		>
			<path d="M12.4 21C12.55 21 12.78 20.95 13 20.82C18.07 17.98 19.81 16.78 19.81 13.52V6.71C19.81 5.77 19.41 5.48 18.65 5.16C17.6 4.72 14.21 3.5 13.15 3.13C12.91 3.05 12.65 3 12.4 3C12.16 3 11.9 3.07 11.67 3.13C10.61 3.44 7.21 4.73 6.16 5.16C5.41 5.47 5 5.77 5 6.71V13.52C5 16.78 6.75 17.97 11.81 20.82C12.04 20.95 12.26 21 12.4 21ZM12.4 19.39C12.26 19.39 12.12 19.33 11.85 19.17C7.74 16.68 6.42 15.95 6.42 13.19V6.98C6.42 6.68 6.47 6.56 6.72 6.47C8.07 5.93 10.7 5.05 12.05 4.51C12.19 4.45 12.31 4.43 12.4 4.43C12.5 4.43 12.62 4.46 12.76 4.51C14.11 5.05 16.72 5.99 18.1 6.47C18.34 6.56 18.39 6.68 18.39 6.98V13.19C18.39 15.95 17.07 16.67 12.96 19.17C12.7 19.33 12.55 19.39 12.4 19.39ZM9.19 15.08C9.19 15.75 9.48 16.06 10.1 16.06H14.71C15.33 16.06 15.62 15.75 15.62 15.08V11.54C15.62 10.91 15.36 10.6 14.84 10.57V9.51C14.84 7.87 13.86 6.78 12.4 6.78C10.95 6.78 9.97 7.87 9.97 9.51V10.57C9.45 10.6 9.19 10.91 9.19 11.54V15.08ZM10.9 10.56V9.42C10.9 8.36 11.51 7.68 12.4 7.68C13.3 7.68 13.91 8.36 13.91 9.42V10.56H10.9Z" />
		</svg>
	)
}

export default LockWalletIcon
